import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import fetchBrandOrder from "@faire/web-api/api/brand-order/brandOrderToken/get";
import { WebApiError } from "@faire/web-api/WebApiError";
import { SubType } from "../responseTypes";
import { orderNumberToBrandOrderToken } from "../utils/orderNumberToBrandOrderToken";
export var handleDelayedMissingPayout = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(args, callback) {
    var _orderData$orders$, orderNumber, brandOrderToken, orderData, brandOrder, _error$httpStatusCode;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          orderNumber = args.params.orderNumber;
          brandOrderToken = orderNumberToBrandOrderToken(orderNumber);
          _context.next = 5;
          return fetchBrandOrder(brandOrderToken);
        case 5:
          orderData = _context.sent;
          brandOrder = (_orderData$orders$ = orderData.orders[0]) === null || _orderData$orders$ === void 0 ? void 0 : _orderData$orders$.brand_orders.find(function (brandOrder) {
            return brandOrder.token === brandOrderToken;
          });
          if (brandOrder) {
            _context.next = 9;
            break;
          }
          return _context.abrupt("return", callback(_defineProperty(_defineProperty({
            ok: false,
            status: 404
          }, SubType.DELAYED_MISSING_PAYOUT, undefined), "error", "Brand order not found")));
        case 9:
          return _context.abrupt("return", callback(_defineProperty(_defineProperty({
            ok: true,
            status: 200
          }, SubType.DELAYED_MISSING_PAYOUT, {
            data: {
              orderStatus: brandOrder.state,
              payoutType: brandOrder.payout_term,
              expectedPayoutDate: brandOrder.payout_due_at
            }
          }), "error", "")));
        case 12:
          _context.prev = 12;
          _context.t0 = _context["catch"](0);
          if (_context.t0 instanceof WebApiError) {
            callback(_defineProperty(_defineProperty({
              ok: false,
              status: (_error$httpStatusCode = _context.t0.httpStatusCode) !== null && _error$httpStatusCode !== void 0 ? _error$httpStatusCode : 500
            }, SubType.DELAYED_MISSING_PAYOUT, undefined), "error", _context.t0.message));
          }
        case 15:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 12]]);
  }));
  return function handleDelayedMissingPayout(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();